import { render, staticRenderFns } from "./BookingDetailUnmap.vue?vue&type=template&id=54a86347&scoped=true"
import script from "./BookingDetailUnmap.vue?vue&type=script&lang=js"
export * from "./BookingDetailUnmap.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailUnmap.vue?vue&type=style&index=0&id=54a86347&prod&lang=scss&scoped=true"
import style1 from "./BookingDetailUnmap.vue?vue&type=style&index=1&id=54a86347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a86347",
  null
  
)

export default component.exports